import React from "react";
import { useNavigate } from "react-router-dom";
import "./Floatingbutton.css";
import floatingimg from "../../asstes/Home/icon-preview.png";

export default function FloatingButton() {
  const navigate = useNavigate();

  return (
    <div className="floating-btn" onClick={() => navigate("/expofinterst")}>
      <span className="floating-label">Expression of Interest</span>

      <img src={floatingimg} alt="Floating Button" />
    </div>
  );
}
